import { useQuery } from "react-query";
import { getSlideShowById } from "../services/SlideShowsApi";

const useSlideshow = (id) => {
    return useQuery(['slideshow', id], () => getSlideShowById(id))
}
 
export default useSlideshow;